"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var memoryStorage = require('./memory-storage');

var cookieStorage = require('./cookie-storage');

var prefix = '_f60';

function set(key, value, storage) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$serialize = options.serialize,
      serialize = _options$serialize === void 0 ? true : _options$serialize;
  var data;

  if (!storage) {
    return undefined;
  }

  if (_typeof(value) === 'object') {
    try {
      data = serialize ? JSON.stringify(value) : value;
    } catch (e) {
      data = value;
    }
  } else {
    data = value;
  }

  var prefixedKey = "".concat(prefix, "_").concat(key);
  storage.setItem(prefixedKey, data, options);
  return data;
}

function get(key, storage) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data;
  var _options$serialize2 = options.serialize,
      serialize = _options$serialize2 === void 0 ? true : _options$serialize2;
  var prefixedKey = "".concat(prefix, "_").concat(key);

  if (!storage) {
    return undefined;
  }

  data = storage.getItem(prefixedKey);

  if (data) {
    try {
      data = serialize ? JSON.parse(data) : data;
    } catch (e) {// it wasn't json
    }
  }

  return data;
}

function remove(key, storage) {
  var prefixedKey = "".concat(prefix, "_").concat(key);

  if (storage) {
    storage.removeItem(prefixedKey);
  }
}

var session = {
  set: function setSessionStorage(key, value) {
    return set(key, value, window.sessionStorage);
  },
  get: function getSessionStorage(key) {
    return get(key, window.sessionStorage);
  },
  remove: function removeSessionStorage(key) {
    return remove(key, window.sessionStorage);
  }
};
var local = {
  set: function setLocalStorage(key, value) {
    return set(key, value, window.localStorage);
  },
  get: function getLocalStorage(key) {
    return get(key, window.localStorage);
  },
  remove: function removeLocalStorage(key) {
    return remove(key, window.localStorage);
  }
};
var memory = {
  set: function setMemoryStorage(key, value) {
    return set(key, value, memoryStorage, {
      serialize: false
    });
  },
  get: function getMemoryStorage(key) {
    return get(key, memoryStorage, {
      serialize: false
    });
  },
  remove: function removeMemoryStorage(key) {
    return remove(key, memoryStorage);
  }
};
var cookie = {
  set: function setCookieStorage(key, value, options) {
    return set(key, value, cookieStorage, options);
  },
  get: function getCookieStorage(key) {
    return get(key, cookieStorage);
  },
  remove: function removeCookieStorage(key) {
    return remove(key, cookieStorage);
  }
};
module.exports = {
  local: local,
  session: session,
  memory: memory,
  cookie: cookie
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/optin/~/@flowio/storage/lib/index.js
// module id = 589
// module chunks = 0 1